import { z } from "zod";

// Canonical justification alignment values from CarouselSlideBase::JustificationAlignment,
// codified in shared_code/domains/channel_push/private/appboy/communication/marketing/carousel_slide_base.rb.
export const justificationAlignmentSchema = z.enum(["start", "center", "end"]);
